<template>
<div class="wrapper">
  <div class="pop-wrap">
    <div class="add-pop">
      <div class="tit_box">
        <h3>Add (Table Title)</h3>
        <button type="button" class="close" data-close="true"><img src="/images/btn_close.png" alt=""></button>
      </div>
      <div class="scrollHeight">
        <ul>
          <li>
            <strong class="star">Test Type ID</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">Error Message Error Message.</div>
            </div>
          </li>
          <li>
            <strong class="star">Test Type</strong>
            <div>
              <div class="filter-item">
                <a href="#;" class="selected-text"><span>Text</span></a>
                <!-- 토글 시 .active 클래스 추가 -->
                <div class="dropdown-wrap">
                  <ul>
                    <li><a href="#;">Text</a></li>
                    <li><a href="#;">Text</a></li>
                    <li><a href="#;">Text</a></li>
                    <li><a href="#;">Text</a></li>
                    <li><a href="#;">Text</a></li>
                    <li><a href="#;">Text</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li>
            <strong class="star">Param1</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">Error Message Error Message.</div>
            </div>
          </li>
          <li>
            <strong class="star">Param2</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">Error Message Error Message.</div>
            </div>
          </li>
          <li>
            <strong class="star">Param3</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">Error Message Error Message.</div>
            </div>
          </li>
          <li>
            <strong class="star">Param4</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">Error Message Error Message.</div>
            </div>
          </li>
          <li>
            <strong class="star">Param5</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">Error Message Error Message.</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">Add</button>
      </div>
    </div>
    <div class="edit-pop">
      <div class="tit_box">
        <h3>Edit (Table Title)</h3>
        <button type="button" class="close"  data-close="true"><img src="/images/btn_close.png" alt=""></button>
      </div>
      <div class="scrollHeight">
        <ul>
          <li>
            <strong class="star">Issue No.</strong>
            <div>
              <div class="input-text big error">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">Issue No. does not exist. Please check again.</div>
            </div>
          </li>
          <li>
            <strong class="star">PLM No.</strong>
            <div>
              <div class="input-text big error">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">PLM No. does not exist. Please check again.</div>
            </div>
          </li>
          <li>
            <strong class="star">App Version</strong>
            <div>
              <div class="input-text big error">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">App Version does not exist. Please check again.</div>
            </div>
          </li>
          <li>
            <strong class="star">OS</strong>
            <div>
              <div class="input-text big error">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">OS does not exist. Please check again.</div>
            </div>
          </li>
          <li>
            <strong class="star">Report and Guide</strong>
            <div>
              <div class="comment small active error">
                <!-- textarea 활성화 시 .active 추가 -->
                <!-- textarea error 시 .error 추가 -->
                <textarea name="" id="" cols="30" rows="10" class="textarea">
                  09-21 06:35:23.943 10387.3.1585 23665 F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus) F libc : Fatal signal 6 (SIGABRT), code -1 (SI_QUEUE) in tid 23665 (UnityMain), pid 31585 (ent.tmgp.sskeus). 
                </textarea>
                <span class="count"><span class="cur">110</span>/9,999</span>
              </div>
              <p class="error-msg">Please enter Report and Guide.</p>
            </div>
          </li>
          <li>
            <strong class="star">Symptom</strong>
            <div>
              <div class="filter-item">
                <a href="#;" class="selected-text"><span>FC/ANR</span></a>
                <!-- 토글 시 .active 클래스 추가 -->
                <div class="dropdown-wrap">
                  <ul>
                    <li><a href="#;">FC/ANR</a></li>
                    <li><a href="#;">Touch</a></li>
                    <li><a href="#;">Sluggish</a></li>
                    <li><a href="#;">Battery Consumption</a></li>
                    <li><a href="#;">Function</a></li>
                    <li><a href="#;">Foldable</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li>
            <strong class="star">Last Comment</strong>
            <div>
              <div class="filter-item">
                <a href="#;" class="selected-text"><span>App</span></a>
                <!-- 토글 시 .active 클래스 추가 -->
                <div class="dropdown-wrap">
                  <ul>
                    <li><a href="#;">App</a></li>
                    <li><a href="#;">Samsung</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">Edit</button>
      </div>
    </div>
    <div class="edit-comment-pop">
      <div class="tit_box">
        <h3>Edit a Comment</h3>
        <button type="button" class="close"  data-close="true"><img src="/images/btn_close.png" alt=""></button>
      </div>
      <div class="scrollHeight">
        <ul>
          <li>
            <strong class="star">Issue No.</strong>
            <div>
              <div class="input-text big error">
                <input type="text" value="Text">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
              <div class="error-msg">Issue No. does not exist. Please check again.</div>
            </div>
          </li>
          <li>
            <strong class="star">Comment </strong>
            <div>
              <div class="comment active error">
                <!-- textarea 활성화 시 .active 추가 -->
                <!-- textarea error 시 .error 추가 -->
                <textarea name="" id="" cols="30" rows="10" class="textarea">
                  @ Samsung (eunhee221.park, paradoxyban)<br>
Could you fix this issue in the next OS, SOS? If you have a fix plan for the issue, please share the schedule.<br>
Also, I checked this issue using chrome browser. When I tested to download the file name included unsupported special characters using pc chrome browser, mobile chrome browser, unsupported special characters are replaced to ".' character. <br>
ex) 1:2/3/4.jpg ==> 1_2_3_4.jpg.
                </textarea>
                <span class="count"><span class="cur">9,999</span>/9,999</span>
              </div>
              <p class="error-msg">You can write up to 999 characters. Please write within 999 characters.</p>
            </div>
          </li>
          <li>
            <strong>File</strong>
            <div>

              <!-- 파일 첨부하기 전 케이스 -->
              <div class="attach-wrap error">
                <!-- 파일 업로드 시 attached 클래스 추가 -->
                <!-- 파일 drag drop 시 attaching 클래스 추가 -->
                <div>
                  <span class="text">Drag files to Upload, or</span>
                  <div class="file-btn">
                    <input type="file" name="file" id="file">
                    <label for="file">Choose File</label>
                  </div>
                </div>
              </div>
              <p class="error-msg">Failed to File Upload. Please try again.</p>
              
              <!-- 파일 첨부된 케이스 -->
              <!-- <div class="attach-wrap attached">
                <div class="attached-item">
                  <span class="name">[SDP] RTL test feature _apk </span>
                  <button type="button"><img src="/images/close.png" alt=""></button>
                </div>
              </div> -->
            </div>
          </li>
        </ul>
      </div>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">Edit</button>
      </div>
    </div>
    <div class="del-pop">
      <div class="tit_box">
        <h3>Delete (Table Title)</h3>
      </div>
      <p class="text_del">
        Sure to Delete?
      </p>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">Delete</button>
      </div>
    </div>
    <div class="del-reg-pop">
      <div class="tit_box">
        <h3>Delete Registered Application List</h3>
      </div>
      <p class="text_del">
        Sure to Delete?
      </p>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">Delete</button>
      </div>
    </div>
    <div class="del-req-pop">
      <div class="tit_box">
        <h3>Delete Requested Application List</h3>
      </div>
      <p class="text_del">
        Sure to Delete?
      </p>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">Delete</button>
      </div>
    </div>
    <div class="complete-pop">
      <div class="tit_box">
        <h3>Complete</h3>
      </div>
      <p class="text_del">
       Successfully registered in the Registered Application List.
      </p>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok" data-close="true">OK</button>
      </div>
    </div>
    <div class="send-pop">
      <div class="tit_box">
        <h3>Complete</h3>
      </div>
      <p class="text_del">
       Successfully sent.
      </p>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok" data-close="true">OK</button>
      </div>
    </div>
    <div class="upload-pop">
      <div class="tit_box">
        <h3>Complete</h3>
      </div>
      <p class="text_del">
       Successfully uploaded.
      </p>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok" data-close="true">OK</button>
      </div>
    </div>
    <div class="del-comment-pop">
      <div class="tit_box">
        <h3>Delete a Comment</h3>
      </div>
      <p class="text_del">
        Sure to Delete?
      </p>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">Delete</button>
      </div>
    </div>
    <div class="excel-pop">
      <div class="tit_box">
        <h3>Export to Excel</h3>
        <button type="button" class="close"  data-close="true"><img src="/images/btn_close.png" alt=""></button>
      </div>
      <p class="text_del">
        Select the date period to export to Excel.
      </p>
      <div class="text_del">
        <div class="excel-radio">
          <input type="radio" name="radio" id="radio1" checked>
          <label for="radio1">
            <span class="text">Previous 3 months period</span>
          </label>
        </div>
        <div class="excel-radio">
          <input type="radio" name="radio" id="radio2" checked>
          <label for="radio2">
            <span class="text">Selected period (MAX : 3 Months)</span>
          </label>
        </div>
      </div>
      <div class="picker-wrap error">
        <date-picker :editable="false" v-model="time1" type="date" placeholder="Select datetime" range :format="format" @change="toggleFooter" @open="open" @close="close" ref="datepicker" :lang="lang">
          <template v-slot:header="{ emit }">
            <button class="mx-btn mx-btn-text" @click="selectPrev7Day(emit)">Previous 7 Days</button>
            <button class="mx-btn mx-btn-text" @click="selectPrev30Day(emit)">Previous 30 Days</button>
            <button class="mx-btn mx-btn-text" @click="selectPrev60Day(emit)">Previous 60 Days</button>
            <button class="mx-btn mx-btn-text" @click="selectPrev90Day(emit)">Previous 90 Days</button>
          </template>
          <template v-slot:footer="{  }">
            <button class="mx-btn mx-btn-text" @click="handleApply">OK</button>
          </template>
          <i slot="icon-calendar"><span class="calendar-icon"><img src="/images/ic-calendar.png" alt=""></span></i>
          <i slot="icon-clear"><span class="clear-icon"><img src="/images/btn_close.png" alt=""></span></i>
        </date-picker>
      </div>
      <p class="error-msg">Please reset the period. You can select Max 3 months.</p>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">OK</button>
      </div>
    </div>
    <div class="column-pop">
      <div class="tit_box">
        <h3>Customize Columns</h3>
        <button type="button" class="close"  data-close="true"><img src="/images/btn_close.png" alt=""></button>
      </div>
      <div class="scrollHeight">
        <div class="checkbox-wrap" id="sortable">
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column1" checked>
              <label for="column1">
                <span>Issue No.</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column2" checked>
              <label for="column2">
                <span>PLM No.</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column3" checked>
              <label for="column3">
                <span>App Version</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column13" checked>
              <label for="column13">
                <span>Package Name</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap">
              <input type="checkbox" name="column" id="column4">
              <label for="column4">
                <span>Model Name</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap">
              <input type="checkbox" name="column" id="column5">
              <label for="column5">
                <span>Model Version</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column6" checked>
              <label for="column6">
                <span>OS</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column7" checked>
              <label for="column7">
                <span>Report and Guide</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column8" checked>
              <label for="column8">
                <span>Symptom</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap">
              <input type="checkbox" name="column" id="column14" checked>
              <label for="column14">
                <span>Reported by</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap">
              <input type="checkbox" name="column" id="column9">
              <label for="column9">
                <span>Reported by (id)</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column10" checked>
              <label for="column10">
                <span>Last Comment</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap">
              <input type="checkbox" name="column" id="column11" checked>
              <label for="column11">
                <span>Last Modified</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
          <div>
            <div class="check-wrap required">
              <input type="checkbox" name="column" id="column12" checked>
              <label for="column12">
                <span>File</span>
              </label>
              <div class="handle"><img src="/images/ic-regular-menu.png" alt=""></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">OK</button>
      </div>
    </div>
    <div class="app-pop">
      <div class="tit_box">
        <h3>Edit Registered Applications List</h3>
        <button type="button" class="close"  data-close="true"><img src="/images/btn_close.png" alt=""></button>
      </div>
      <div class="list-box">
        <ul>
           <li>
            <strong class="">No.</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="15">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
            </div>
          </li>
           <li>
            <strong class="star">Package Name</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="com.nhn.adroid.navercafe">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
            </div>
          </li>
           <li>
            <strong class="star">App Name</strong>
            <div>
              <div class="input-text big">
                <input type="text" value="Naver Cafe">
                <button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="bnt_botten">
        <button type="button" data-close="true">Cancel</button>
        <button type="button" class="ok">Edit</button>
      </div>
    </div>
  </div>

</div>
</template>
<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  export default {
    components: { DatePicker },
    data() {
      return {
        time1: null,
        time2: null,
        format: "YY-MM-DD",
        lang: {
          formatLocale: {
            weekdaysMin: ['S ', 'M', 'T ', 'W', 'T', 'F', 'S'],
          },
        },
        openpop : null
      };
    },
    methods: {
      selectPrev7Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 7 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev30Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 30 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev60Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 60 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev90Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 90 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      toggleFooter (value, type) {
        if (type === 'date') {
          const footer = document.getElementsByClassName('mx-datepicker-footer')[0];
          footer.classList.add('on');
        }
      },
      open () {
        const filterBox = document.getElementsByClassName('mx-datepicker')[0];
        filterBox.classList.remove('active');
      },
      close () {
        const filterBox = document.getElementsByClassName('mx-datepicker')[0];
        filterBox.classList.remove('active');
      },
      handleApply () {
        this.$refs.datepicker.closePopup();
      }
    },
  }
</script>
<style scoped>

/* common */
.sr-only { position: absolute; top: 0; left: 0; width: 0; height: 0; overflow: hidden; visibility: hidden; font-size: 0; line-height: 0; } 
/* /common */

/* =========== LAYOUT ========== */
.content-box { height: 100%; padding: 40px 24px; } 
.content-inner { max-width: 1000px; margin: auto; } 
@media all and (max-width: 1000px){
 .content-box { padding: 32px 24px 120px; } 
 }

/* =========== COMPONENTS ========== */
.h2 { display: block; margin-top: 20px; font-family: SamsungSharpSans-Medium; font-size: 40px; font-weight: 500; line-height: 1.5; letter-spacing: -0.13px; color: #000; } 
.h3 { display: block; margin-top: 42px; padding: 22px 0; font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 

@media all and (max-width: 1000px){
 .h2 { margin-top: 0; font-size: 36px; line-height: 1.22; letter-spacing: -0.1px; } 
 }

/* button */
.filled-btn { display: inline-block; width: 200px; padding: 15px 24px; border-radius: 4px; font-size: 16px; font-weight: bold; line-height: normal; text-align: center; color: #fff; background-color: #0f42cf; vertical-align: middle; font-family: SamsungOne; } 
.lined-btn { display: inline-block; width: 200px; padding: 15px 24px; border-radius: 4px; border: 1px solid #d6d6d6; font-size: 16px; font-weight: bold; line-height: normal; text-align: center; color: #363636; background-color: #fff; vertical-align: middle; font-family: SamsungOne;} 
.filled-btn:hover:not([disabled]) { background-color: #002ba3; } 
.lined-btn:hover:not([disabled]) { background-color: #d6d6d6; } 
/* /button */
/* checkbox */
.checkbox-wrap.error + .error-msg { display: block; }
.checkbox-wrap + .error-msg { font-size: 14px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: 1.43; letter-spacing: normal; color: #ec2000; display: none; margin: 8px 0 0 0; }
.check-wrap { display: block; padding: 9px 40px; background: #fff; position: relative; } 
.check-wrap input[type="checkbox"] { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; } 
.check-wrap input[type="checkbox"] + label span { position: relative; display: inline-block; padding: 2px 12px 0 26px; font-size: 16px; line-height: 1.25; letter-spacing: -0.11px; color: #363636; } 
.check-wrap input[type="checkbox"] + label span:before { content: ""; position: absolute; left: 0; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/icon_checkbox.png) no-repeat center / cover; } 
.check-wrap.required input[type="checkbox"] + label span:after { content: "*"; position: absolute; right: 0; top: 0; font-size: 16px; line-height: 1.25; letter-spacing: -0.11px; color: #ec2000; } 
.check-wrap input[type="checkbox"]:checked + label span:before { background-image: url(/images/icon_checkbox_on.png) !important; } 
.check-wrap.required input[type="checkbox"]:checked + label span:before { opacity: 0.4; } 
.check-wrap.required input[type="checkbox"]:checked + label { pointer-events: none; } 
.check-wrap.error input[type="checkbox"] + label span:before { background-image: url(/images/icon_checkbox_error.png); }

.check-wrap .handle { position: absolute; right: 40px; top: 50%; transform: translateY(-50%); width: 24px; height: 24px; display: none; }
.check-wrap .handle img {width: 100%;}
.ui-sortable-helper .check-wrap { box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2); }
@media (hover: hover) {
  .check-wrap:hover .handle { display: block; }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .check-wrap:hover .handle { display: block; }
}
/* /checkbox */
/* radio */
.excel-radio + .excel-radio {margin-top:10px;}
.excel-radio input { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; } 
.excel-radio label .text { position: relative; display: inline-block; padding-left: 24px; font-size: 16px; line-height: 1.5; letter-spacing: -0.16px; color: #363636; cursor: pointer; text-align: left; } 
.excel-radio label .text:before { content: ""; position: absolute; left: 0; top: 2px; width: 16px; height: 16px; background: url(/images/radio-off.png) no-repeat center / cover; } 
.excel-radio input:checked + label .text:before { background-image: url(/images/radio-on.png); } 
/* /radio */

.right-wrap { margin-bottom: 40px; text-align: right; } 
.right-wrap .check-wrap + .filled-btn { margin-left: 16px; } 
/* input */
.input-text { position: relative; padding: 0 12px; border-radius: 4px; border: solid 1px #d6d6d6; background-color: #fff; } 
.input-text.big { padding: 0 12px; } 
.input-text.search { padding-left: 32px; background: url(/images/input-search.png) no-repeat #fff 8px center / 16px 17px; } 
.input-text input[type="text"] { width: 100%; height: 30px; line-height: 20px; font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; font-size: 14px; color: #363636; } 
.input-text input[type="text"] + button { display: none; position: absolute; right: 8px; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; padding: 3px; line-height: 0; font-size: 0; } 
.input-text input[type="text"] + button img { max-width: 100%; } 
.input-text.active input[type="text"] + button { display: block; } 
.input-text.active.error input[type="text"] + button { display: none; } 
.input-text.active { padding-right: 32px; } 
.input-text.big input[type="text"] { height: 46px; font-size: 16px; line-height: 1.38; } 
.input-text.active { border-color: #0f42cf; } 
.input-text.error { border-color: #ec2000; padding-right: 36px; background: url(/images/error.png) no-repeat #fff calc(100% - 9px) center / 16px; } 
.input-text.error + .error-msg { display: block; } 
.input-text.error { border-color: #ec2000; padding-right: 36px; background: url(/images/error.png) no-repeat #fff calc(100% - 9px) center / 16px; } 
.input-text.big.error { padding-right: 48px; background-size: 24px; } 
.input-file { position: relative; border-radius: 4px; border: solid 1px #d6d6d6; } 
.input-file input[type="file"] { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; } 
.input-file input[type="file"] + label { display: block; width: 32px; height: 32px; font-size: 0; line-height: 0; background: url(/images/attachment.png) no-repeat center transparent; background-size: 16px; cursor: pointer; } 
.textarea { width: 100%; height: 100px; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #363636; resize: none; scrollbar-width: none; -ms-overflow-style: none; overflow-x: scroll; } 
.textarea::-webkit-scrollbar { display: none; } 
/* /input */
.comment { position: relative; margin-top: 16px; padding: 16px 16px 36px; border-radius: 4px; border: solid 1px #d6d6d6; background-color: #fff; } 
.comment .textarea { height: 228px; font-size: 16px; line-height: 1.38; color: #000; font-family: SamsungOne; }
.comment.small .textarea { height: 108px; }
.comment.error { border-color: #ec2000; } 
.error-msg { display: none; margin: 8px 0 0 0; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #ec2000; } 
.comment.error + .error-msg { display: block; } 
.comment.active .count .cur { color: #363636; }
.comment .count { position: absolute; bottom: 8px; right: 12px; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #9e9e9e; }

@media all and (max-width: 1000px){
 .comment { margin-top: 8px; } 
 .comment .textarea {font-size: 14px;}
.input-file input[type="file"] + label { width: 40px; background-size: 24px; } 
.input-text.big { padding: 0 12px; } 
.input-text.big input[type="text"] { height: 38px; font-size: 14px; }
 }

 .attach-wrap { position: relative; display: flex; flex-direction: column; justify-content: center; min-height: 160px; padding: 16px; border: 2px solid rgba(214,214,214,0.5); text-align: center; border-radius: 4px; } 
.attach-wrap.attached { display: block; text-align: left; } 
.attach-wrap.attaching { border: 1px solid #0f42cf; } 
.attach-wrap.error { border: 1px solid #ec2000; } 
.attach-wrap.error + .error-msg { display: block; } 
.attach-wrap .text { display: block; margin-bottom: 16px; font-size: 16px; line-height: 1.5; color: #363636; } 
.attach-wrap .file-btn input[type="file"] { position: absolute; width: 0; height: 0; opacity: 0; cursor: pointer; } 
.attach-wrap .file-btn input[type="file"] + label { display: inline-block; padding: 7px 24px; border-radius: 4px; font-size: 14px; font-weight: bold; line-height: normal; color: #363636; cursor: pointer; border: 1px solid rgba(0, 0, 0, 0.2) } 

.attach-wrap .attached-item { position: relative; padding: 17px 24px; margin-top: 0 !important; border: solid 1px #d6d6d6; background-color: #f7f7f7; } 
.attach-wrap .attached-item .name { display: block; max-width: 100%; margin-right: 28px; padding: 0 0 0 28px; font-size: 14px; line-height: 1.43; text-overflow: ellipsis; overflow: hidden; max-height: 40px; -webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; color: #0f42cf; background: url(/images/file.png) no-repeat left 2px; background-size: 16px; font-family: Arial; } 
.attach-wrap .attached-item a:hover {text-decoration: underline;}
.attach-wrap .attached-item button { position: absolute; top: 12px; right: 16px; width: 16px; height: 16px; line-height: 0; font-size: 0; } 
.attach-wrap .attached-item button img { max-width: 100%; } 

.test-bottom { margin-top: 40px; text-align: center; } 
.test-bottom .notice { display: block; margin-bottom: 12px; font-size: 16px; line-height: 1.5; color: #9e9e9e; } 

/* filter-wrap */
.filter-wrap { margin-top: 40px; } 
.filter-box ul { display: flex; margin: 0 -4px; } 
.filter-box ul li { position: relative; flex: 1 1 0px; width: 16.66%; padding: 0 4px; } 
.filter-item { position: relative; text-align: left; } 
.filter-item .title { display: block; margin-bottom: 6px; font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; } 
.filter-item .input-text.active + .dropdown-wrap { display: block; } 
.filter-item .selected-text { position: relative; display: block; padding: 13px 36px 13px 16px; border-radius: 4px; border: solid 1px #d6d6d6; font-size: 16px; line-height: 1.38; color: #363636; } 
.filter-item .selected-text:before { content: ""; position: absolute; top: 50%; right: 12px; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/arrow-light.png) no-repeat center / cover; } 
.filter-item .selected-text.active { border-color: #0f42cf; } 
.filter-item .selected-text.active:before { transform: translateY(-50%) rotate(180deg); } 
.filter-item .selected-text span { display: block; max-width: 100%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; } 
.filter-item .selected-text.active + .dropdown-wrap { display: block; } 
.filter-item.error .selected-text { border-color: #ec2000; } 
.filter-item.error + .error-msg { display: block; } 
.dropdown-wrap { display: none; position: absolute; top: calc(100% + 4px); left: 0; right: 0; background-color: #fff; z-index: 10; padding-bottom: 40px; margin-top: 0 !important; } 
.dropdown-wrap ul { display: block; margin: 0; padding: 8px 0; border-radius: 4px; border: solid 1px #d6d6d6; } 
.dropdown-wrap ul li { flex: none; width: 100%; padding: 0; } 
.dropdown-wrap ul li + li { margin-top: 0 !important; } 
.dropdown-wrap ul li a { display: block; padding: 9px 16px; font-size: 16px; line-height: 1.38; } 
.dropdown-wrap ul li.recent a { padding-left: 40px; background: url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.dropdown-wrap ul li:hover a { background-color: rgba(15,66,207,0.1); } 
.filter-selected { margin-top: 6px; padding: 24px; border: solid 1px #d6d6d6; border-radius:4px; } 
.filter-selected .textarea { height: 184px; font-size: 16px; line-height: 1.5; letter-spacing: normal; color: #363636; } 
.bottom { margin-top: 40px; text-align: center; } 
.reg-item + .bottom { margin-top: 60px; } 
.bottom ul { text-align: center; } 
.bottom ul li { display: inline-block; padding: 0 8px; } 
@media all and (max-width: 1000px){
 .attach-wrap.only { height: 330px; } 
 .filter-wrap { margin-top: 24px; } 
 .filter-box ul { display: block; margin: 0; } 
 .filter-box ul li { flex: none; width: 100%; padding: 0; } 
 .filter-box > ul > li + li { margin-top: 16px; } 
 .filter-selected { margin-top: 8px; } 
.filter-title {margin-bottom:0;}
 .bottom .filled-btn.big { width: 100%; } 
 .bottom .lined-btn.big { width: 100%; } 
 .bottom ul { text-align: center; margin: 0 -4px; } 
 .bottom ul li { display: inline-block; width: 50%; padding: 0 4px; } 
 .reg-item + .bottom { margin-top: 40px; } 
.input-text input[type="text"] + button { right: 12px; }
 .filter-item .selected-text { padding-top: 8px; padding-bottom: 8px; font-size: 14px; } 
 .dropdown-wrap ul li a {font-size: 14px;}
 }

 .attach-wrap + .input-text-wrap { margin-top: 40px; } 
 .input-text-wrap { position: relative; } 
.input-text-wrap .text { position: relative; display: inline-block; margin-right: 4px; padding-right: 8px; vertical-align: middle; font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #9e9e9e; } 
.input-text-wrap .text:before { content: ":"; position: absolute; top: 50%; right: 0; transform: translateY(-50%); } 
.input-text-wrap .picker-wrap { display: inline-block; width: 260px; vertical-align: middle; } 
.input-text-wrap .select-wrap { display: inline-block; width: 260px; vertical-align: middle; } 
.input-text-wrap .selects > button { width: 100%; height: 48px; font-size: 16px; line-height: 1.38; color: #9e9e9e; } 
.input-text-wrap .selects > button.active + .absList { display: block; } 
.input-text-wrap .selects .absList { z-index: 10; } 

/* datetimepicker */
.mx-datepicker-range {width: 100%; } 
.mx-datepicker >>> .mx-input {max-width: 100%; height: 48px;padding: 13px 70px 13px 16px; border-color: #d6d6d6;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 16px; line-height: 1.38; letter-spacing: normal; color: #000; font-family: SamsungOne; } 
.mx-datepicker >>> .mx-input:hover {border-color: #d6d6d6; } 
.mx-datepicker >>> .mx-input:focus {border-color: #0f42cf; } 
.mx-datepicker >>> .mx-input::placeholder {font-weight: normal !important; } 
.mx-datepicker >>> .mx-icon-calendar {right: 12px; } 
.picker-wrap >>> .mx-icon-clear {right: 44px; font-size: 0; }
.clear-icon {display: block;width: 16px;height: 16px; }  
.mx-datepicker >>> .calendar-icon {display: block;width: 24px;height: 24px; } 
.mx-datepicker >>> .calendar-icon img, .clear-icon img { width: 100%; } 
.mx-datepicker.active .calendar-icon { opacity: 1; } 
.mx-icon-left:before, .mx-icon-right:before, .mx-icon-double-left:before, .mx-icon-double-right:before, .mx-icon-double-left:after, .mx-icon-double-right:after {width: 14px;height: 14px;margin-left: -4px;border-width: 3px 0 0 3px;border-color: #000; } 
.mx-calendar-panel-month .mx-icon-left:after, .mx-calendar-panel-month .mx-icon-right:after, .mx-calendar-panel-month .mx-icon-double-left:after, .mx-calendar-panel-month .mx-icon-double-right:after {display: none; } 
.mx-calendar-panel-year .mx-icon-left:after, .mx-calendar-panel-year .mx-icon-right:after, .mx-calendar-panel-year .mx-icon-double-left:after, .mx-calendar-panel-year .mx-icon-double-right:after {display: none; } 
.picker-wrap >>> .mx-input-wrapper .mx-icon-clear{display:block}
.picker-wrap >>> .mx-input-wrapper:hover .mx-icon-clear{display:block}
.picker-wrap >>> .mx-input-wrapper:hover .mx-icon-clear+.mx-icon-calendar{display:block}


/* calendar */
.mx-datepicker-main {border-radius: 4px; } 
.mx-datepicker-header {padding: 12px 0;border-color: #ebebed; } 
.mx-datepicker-header .mx-btn { margin: 0 7px;padding: 2px 8px; border-radius: 4px;font-size: 12px; line-height: 1.67; letter-spacing: -0.12px; color: rgba(54,54,54,0.8);font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-datepicker-header .mx-btn:first-child {margin-left: 5px; } 
.mx-datepicker-header .mx-btn:hover { background-color: rgba(15,66,207,0.1); } 
.mx-datepicker-footer {display: none;padding: 12px 16px; } 
.mx-datepicker-footer.on {display: block; } 
.mx-datepicker-footer .mx-btn {padding: 5px 16px 4px; border-radius: 4px; border: solid 1px #0f42cf;color: #0f42cf;font-weight: bold;font-size: 12px;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif;line-height: normal; } 
.mx-calendar {padding: 0 16px 32px; } 

/* header, footer */
.mx-calendar-header, .mx-time-header {margin-top: 16px;height: 36px;line-height: 36px; } 
.mx-calendar-header-label .mx-btn,
.mx-time-header .mx-btn,
.mx-calendar-header-label {font-size: 16px;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif;font-weight: bold;color: #363636; } 
.mx-table th {font-size: 12px;font-weight: normal; color: #d6d6d6; } 
.mx-table-date td {color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-table-date .cell.not-current-month {color: #d6d6d6; } 
.mx-table-date .today {color: #0f42cf; } 
.mx-calendar-content .cell.active {border-radius: 4px;background-color: #0f42cf; } 
.mx-calendar-content .cell.in-range,
.mx-calendar-content .cell.hover-in-range,
.mx-calendar-content .cell:not(.active):hover {background-color: rgba(15,66,207,0.1); } 

/* time */
.mx-time-content {padding: 0 26px; } 
.mx-time-header {border: none; } 
.mx-time-column {margin: 0 5px;border: none; } 
.mx-time-column .mx-time-item {height: 24px;line-height: 24px;border-radius: 4px;color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-time-column .mx-time-item:hover {background-color: rgba(15,66,207,0.1); } 
.mx-time-column .mx-time-item.active {color: #fff;font-weight: normal;background-color: #0f42cf; } 
.mx-time-column .mx-time-list::after {display: none; } 

/* month, year */
.mx-calendar-panel-month,
.mx-calendar-panel-year {padding: 0 36px; } 
.mx-calendar-panel-month .mx-calendar-header, .mx-time-header,
.mx-calendar-panel-year .mx-calendar-header, .mx-time-header {margin: 16px -20px 0; } 
.mx-table.mx-table-month {height: 180px; } 
.mx-table-month .cell,
.mx-table-year .cell {padding: 0 4px;color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-table-month .cell div,
.mx-table-year .cell div {padding: 5px;border-radius: 4px; } 
.mx-table-month .cell.active,
.mx-table-year .cell.active {background-color: transparent; } 
.mx-table-month .cell.active div,
.mx-table-year .cell.active div {padding: 5px 0;border-radius: 4px;background-color: #0f42cf; } 
.mx-table-month .cell:not(.active):hover,
.mx-table-year .cell:not(.active):hover {background-color: transparent;color: #363636; } 
.mx-table-month .cell:not(.active):hover div,
.mx-table-year .cell:not(.active):hover div {background-color: rgba(15,66,207,0.1); } 
/* /datetimepicker */
@media all and (max-width:1000px){
 .input-text-wrap .text { display: block; margin-right: 0; margin-bottom: 8px; padding-right: 0; } 
 .input-text-wrap .text:before { display: none; } 
 .input-text-wrap .picker-wrap { width: 100%; } 
 .mx-calendar,
 .mx-time { width: 100%; } 
 .mx-datepicker-popup { max-height: 80vh; overflow-x: auto; } 
 .input-text-wrap .select-wrap { width: 100%; } 
 }


.pop-wrap {position: fixed; left:0; top:0; bottom: 0; width:100%; display:none; z-index:31;}
.pop-wrap::before {content:''; position: absolute; left:0; top:0; width:100%; height:100%; background:#000; opacity: 0.3;}
.pop-wrap .tit_box {position: relative; padding:0 40px;}
.pop-wrap .tit_box .close {position: absolute; right:40px; top:50%; transform: translateY(-50%);}
.pop-wrap .tit_box .close img {width:24px;}
.pop-wrap .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000;}
.pop-wrap .scrollHeight {margin-top:40px; height:676px; max-height:calc(100vh - 330px); overflow-y:auto;  padding:40px 40px 0; border-top: 1px solid #ebebed;  border-bottom: 1px solid #ebebed; }
.pop-wrap .scrollHeight:after { content: ""; display: block; padding-bottom: 40px; }
.pop-wrap .scrollHeight::-webkit-scrollbar {width: 4px;}
.pop-wrap .scrollHeight::-webkit-scrollbar-track {background:#fff;}
.pop-wrap .scrollHeight::-webkit-scrollbar-thumb {background-color: #d7d7d7; border-radius: 2px;}
.pop-wrap .scrollHeight li strong {font-size: 16px; font-weight: bold; line-height: 1.5; letter-spacing: -0.16px; color: #6e6e6e;}
.pop-wrap .scrollHeight li strong.star {position: relative; padding-right:10px;}
.pop-wrap .scrollHeight li strong.star::after {content:'*'; font-size: 14px; font-weight: bold; line-height: 1.14; letter-spacing: -0.1px; color: #ec2000; position: absolute; right:0; top:-2px;}
.pop-wrap .scrollHeight li div {margin-top:8px;}
.pop-wrap .scrollHeight li select {width:100%; height: 48px; border-radius: 4px; border: solid 1px #d6d6d6; background-color: #ffffff; box-sizing: border-box; appearance:none; background:url(/images/icon_select_black.png) 98% center no-repeat; background-size:16px; font-size: 16px; line-height: 1.38; color: #363636; padding:0 16px;}
.pop-wrap .scrollHeight li + li {margin-top:16px;}
.pop-wrap .bnt_botten { display:flex; justify-content: center;  padding:40px 40px 0;}
.pop-wrap .bnt_botten button { width: 96px; margin: 0 8px; height:48px; font-size: 16px; font-weight: bold; line-height: 1.5; text-align: center; color: #363636; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne;}
.pop-wrap .bnt_botten button.ok {border-color:#0f42cf; background:#0f42cf; color:#fff;}
.pop-wrap .bnt_botten button.ok.ready {opacity: 0.3;}
.pop-wrap .add-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:560px; max-height: 920px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .edit-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:560px; max-height: 920px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .edit-comment-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:560px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .del-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .del-pop .tit_box {padding:0 40px;}
.pop-wrap .del-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; text-align:center;}
.pop-wrap .del-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
.pop-wrap .del-reg-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .del-reg-pop .tit_box {padding:0 40px;}
.pop-wrap .del-reg-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; text-align:center;}
.pop-wrap .del-reg-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
.pop-wrap .del-req-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .del-req-pop .tit_box {padding:0 40px;}
.pop-wrap .del-req-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; text-align:center;}
.pop-wrap .del-req-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
.pop-wrap .complete-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .complete-pop .tit_box {padding:0 40px;}
.pop-wrap .complete-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; text-align:center;}
.pop-wrap .complete-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px; padding: 0 40px;}
.pop-wrap .send-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .send-pop .tit_box {padding:0 40px;}
.pop-wrap .send-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; text-align:center;}
.pop-wrap .send-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
.pop-wrap .upload-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .upload-pop .tit_box {padding:0 40px;}
.pop-wrap .upload-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; text-align:center;}
.pop-wrap .upload-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
.pop-wrap .del-comment-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .del-comment-pop .tit_box {padding:0 40px;}
.pop-wrap .del-comment-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; text-align:center;}
.pop-wrap .del-comment-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
.pop-wrap .excel-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .excel-pop .tit_box {margin-bottom: 40px;}
.pop-wrap .excel-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; }
.pop-wrap .excel-pop .text_del { padding: 0 40px; font-size: 16px; line-height: 1.5; letter-spacing: -0.16px; color: #363636; margin-top:20px;}
.pop-wrap .excel-pop .picker-wrap {width: 100%; margin: 16px auto 0; padding: 0 40px 0 64px;}
.pop-wrap .excel-pop .mx-datepicker >>> .mx-input{ height: 48px; font-size: 16px; font-family: SamsungOne; padding: 0 56px 0 16px; box-shadow: none; }
.pop-wrap .excel-pop .picker-wrap.error >>> .mx-input { border-color: #ec2000; }
.pop-wrap .excel-pop .mx-datepicker .calendar-icon { width: 24px; height: 24px; }
.pop-wrap .excel-pop .error-msg { display: none; margin: 8px auto 0; padding: 0 40px 0 64px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #ec2000; }
.pop-wrap .excel-pop .picker-wrap.error + .error-msg { display: block; }
.pop-wrap .column-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .column-pop .scrollHeight { padding: 31px 0 0; max-height: 638px; }
.pop-wrap .column-pop .scrollHeight:after { padding-bottom: 31px; }
.pop-wrap .column-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; }
.pop-wrap .app-pop {position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:40px 0; width:520px; border-radius:6px; background:#fff; box-sizing: border-box;  display:none;}
.pop-wrap .app-pop .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.24px; color: #000000; }
.pop-wrap .app-pop .list-box { padding: 0 40px; margin-top: 40px; }
.pop-wrap .app-pop .list-box ul li + li { margin-top: 16px; }
.pop-wrap .app-pop .list-box li strong {font-size: 16px; font-weight: bold; line-height: 1.5; letter-spacing: -0.16px; color: #6e6e6e;}
.pop-wrap .app-pop .list-box li strong.star {position: relative; padding-right:10px;}
.pop-wrap .app-pop .list-box li strong.star::after {content:'*'; font-size: 14px; font-weight: bold; line-height: 1.14; letter-spacing: -0.1px; color: #ec2000; position: absolute; right:0; top:-2px;}
.pop-wrap .app-pop .list-box li div {margin-top:8px;}

@media all and (max-width:1000px){
  .pop-wrap .add-pop {padding:0; width:calc(100% - 48px); max-width:560px;}
  .pop-wrap .edit-pop {padding:0; width:calc(100% - 48px); max-width:560px;}
  .pop-wrap .edit-comment-pop {padding:0; width:calc(100% - 48px); max-width:560px;}
  .pop-wrap .del-pop {padding:0; width:calc(100% - 48px); max-width:520px;}
  .pop-wrap .del-comment-pop {padding:0; width:calc(100% - 48px); max-width:520px;}
  .pop-wrap .tit_box {position: relative; padding:0 16px; padding-top:56px;}
  .pop-wrap .tit_box .close {position: absolute; right:16px; top:16px; transform: translateY(0%);}
  .pop-wrap .tit_box .close img {width:24px;}
  .pop-wrap .tit_box h3 {font-size: 24px; font-weight: bold; line-height: 1.33; letter-spacing: -0.08px; text-align: center; color: #000000;}
  .pop-wrap .scrollHeight {margin-top:40px; height:calc(100vh - 300px); max-height:548px; overflow-y:auto;  padding:32px 16px 0;}
  .pop-wrap .scrollHeight:after { padding-bottom: 32px; }
  .pop-wrap .scrollHeight::-webkit-scrollbar {width: 4px;}
  .pop-wrap .scrollHeight::-webkit-scrollbar-track {background:#fff;}
  .pop-wrap .scrollHeight::-webkit-scrollbar-thumb {background-color: #d7d7d7; border-radius: 2px;}
  .pop-wrap .scrollHeight li strong {font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #9e9e9e;}
  .pop-wrap .scrollHeight li strong.star {position: relative; padding-right:10px;}
  .pop-wrap .scrollHeight li strong.star::after {content:'*'; font-size: 14px; font-weight: bold; line-height: 1.14; letter-spacing: -0.1px; color: #ec2000; position: absolute; right:0; top:-2px;}
  .pop-wrap .scrollHeight li div {margin-top:8px;}
  .pop-wrap .scrollHeight li select {width:100%; height: 48px; border-radius: 4px; border: solid 1px #d6d6d6; background-color: #ffffff; box-sizing: border-box; appearance:none; background:url(/images/icon_select_black.png) 98% center no-repeat; background-size:16px; font-size: 16px; line-height: 1.38; color: #363636; padding:0 16px;}
  .pop-wrap .bnt_botten { padding:16px; }
  .pop-wrap .bnt_botten button { margin: 0 4px; }
  .pop-wrap .bnt_botten button.ok {border-color:#0f42cf; background:#0f42cf; color:#fff;}
  .pop-wrap .bnt_botten button.ok.ready {opacity: 0.3;}
  .pop-wrap .del-pop .tit_box {padding-top:40px;}
  .pop-wrap .del-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
  .pop-wrap .del-pop .text_del + .bnt_botten {margin-top:16px; padding-bottom:32px;}
  .pop-wrap .del-reg-pop {max-width: calc(100% - 48px); padding: 0 0 16px;}
  .pop-wrap .del-reg-pop .tit_box {padding-top:40px;}
  .pop-wrap .del-reg-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
  .pop-wrap .del-reg-pop .text_del + .bnt_botten {margin-top:16px;}
  .pop-wrap .del-req-pop {max-width: calc(100% - 48px); padding: 0 0 16px;}
  .pop-wrap .del-req-pop .tit_box {padding-top:40px;}
  .pop-wrap .del-req-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
  .pop-wrap .del-req-pop .text_del + .bnt_botten {margin-top:16px;}
  .pop-wrap .complete-pop {max-width: calc(100% - 48px); padding: 0 0 16px;}
  .pop-wrap .complete-pop .tit_box {padding-top:40px;}
  .pop-wrap .complete-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px; padding: 0 16px;}
  .pop-wrap .complete-pop .text_del + .bnt_botten {margin-top:16px; }
  .pop-wrap .send-pop {max-width: calc(100% - 48px); padding: 0 0 16px;}
  .pop-wrap .send-pop .tit_box {padding-top:40px;}
  .pop-wrap .send-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
  .pop-wrap .send-pop .text_del + .bnt_botten {margin-top:16px; }
  .pop-wrap .upload-pop {max-width: calc(100% - 48px); padding: 0 0 16px;}
  .pop-wrap .upload-pop .tit_box {padding-top:40px;}
  .pop-wrap .upload-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
  .pop-wrap .upload-pop .text_del + .bnt_botten {margin-top:16px; }
  .pop-wrap .del-comment-pop .tit_box {padding-top:40px;}
  .pop-wrap .del-comment-pop .text_del {font-size: 20px; line-height: 1.4; letter-spacing: -0.2px; text-align: center; color: #363636; margin-top:16px;}
  .pop-wrap .del-comment-pop .text_del + .bnt_botten {margin-top:16px; padding-bottom:32px;}
  .pop-wrap .excel-pop { padding:0; max-width: calc(100% - 48px); }
  .pop-wrap .excel-pop .bnt_botten { padding-top: 32px; }
  .pop-wrap .excel-pop .text_del { padding: 0 17px; }
  .pop-wrap .excel-pop .picker-wrap { padding: 0 16px 0 40px; }
  .pop-wrap .excel-pop .mx-datepicker >>> .mx-input{ height: 40px; font-size: 14px;}
  .pop-wrap .excel-pop .picker-wrap.error + .error-msg { padding: 0 16px 0 40px;}
  .pop-wrap .column-pop { padding:0; max-width: calc(100% - 48px); }
  .pop-wrap .app-pop { padding:0 0 16px; max-width: calc(100% - 48px); }
  .pop-wrap .app-pop .list-box { padding: 0 16px; margin-bottom: 16px; }
  .pop-wrap .app-pop .list-box li strong {font-size: 14px; line-height: 1.43; letter-spacing: -0.14px;}
}


/* ============== table ============== */
.tableWrap { position: relative; width:100%; max-width:1000px; margin-top:40px; } 
.tableWrap .titArea { position: relative; padding:24px 0 16px; min-height: 68px; } 
.tableWrap .titArea .tit { font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 
.tableWrap .titArea .alignRight { position: absolute; right:0; bottom: 0; display:flex; align-items: flex-end; } 
.tableWrap .titArea .alignRight .excel { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .del { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .edit { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .add { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap.titOn { } 
.tableWrap.titOn .titArea { z-index:20; } 
.tableWrap.titOn .tableSt01 { position: relative; z-index:10; } 
.tableSt01 { } 
.tableSt01.headOn > table { position: relative; z-index:10; } 
.tableSt01.headOn > .scroll { position: relative; z-index:9; } 
.tableSt01 table { table-layout: fixed; } 
.tableSt01 thead th { position: relative;  background:#f7f7f7; border-bottom:1px solid #ebebed; text-align:left; } 
.tableSt01 thead th .inbox { position: relative; padding:15px 8px; min-height:56px; } 
.tableSt01 thead th .inbox::after { content:''; width:1px; height:52px; position: absolute; right:0; top:50%; transform: translateY(-50%); background:#ebebed; } 
.tableSt01 thead tr th:last-child .inbox::after { display:none; } 
.tableSt01 thead th .str { display:flex; justify-content: space-between; min-height: 34px; align-items: center; } 
.tableSt01 thead th.file .str { justify-content: center; } 
.tableSt01 thead th .str > strong { font-size: 13px; font-weight: bold; line-height: 1.38; letter-spacing: -0.09px; color: #363636; } 
.tableSt01 thead th .str button img { width:16px; } 
.tableSt01 thead th.center { text-align:center; } 
.tableSt01 thead th.center .inbox { padding:0; justify-content: center; display: flex; align-items: center; } .tableSt01 thead .only th .inbox { padding: 20px 8px 20px 16px; }
.tableSt01 thead .only th .inbox::after { height:32px; } 
.fileFlus { position: absolute; top:154px; right:-10px; z-index:30;} 
.fileFlus > button img { width:24px; } 
.fileFlus.curr .absList { display:block; z-index:20; } 
.fileFlus .absList { position: absolute; right:0; top:100%; width:214px; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; } 
.fileFlus .absList .all { margin: 0 8px; padding:10px 0; border-bottom:1px solid #ebebed; } 
.fileFlus .absList ul { padding-top:8px; } 
.fileFlus .absList li { padding:10px 8px; } 
.fileFlus .absList li:hover { background:#e6ecfb; } 
.fileFlus .absList label { font-family: SamsungOne; font-size: 14px; font-weight:normal; line-height: 1.43; color: #363636; margin-left:8px; } 
.fileFlus .absList .btns { padding:8px 8px 0; display: flex; justify-content: space-between; margin-top:8px; } 
.fileFlus .absList .btns button { width:calc(50% - 4px); height: 32px; border-radius: 4px; } 
.fileFlus .absList .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.fileFlus .absList .btns button.btnRe { font-size: 14px; font-weight: bold; color: #363636; background-color: #fff; border: solid 1px #d6d6d6; } 


.tableSt01 tbody td { border-bottom:1px solid #ebebed; text-align:left; vertical-align: middle; } 
.tableSt01 tbody td.center { text-align:center; } 
.tableSt01 tbody td.middle { vertical-align: middle; } 
.tableSt01 tbody td.ellipsis p { max-width: 100%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; } 

.innerTable.with-filter .tableSt01 tbody .blues {display: none;}
.innerTable.with-filter .tableSt01 tbody .blues.curr {display: table-row;}
.tableSt01 tbody .blues {display: table-row;}
.tableSt01 tbody .blues.curr {display:table-row;}
.tableSt01 tbody .blues td { background-color: rgba(15, 66, 207, 0.03); } 
.tableSt01 tbody .blues td.removeBr { background-color:#fff; } 
.tableSt01 tbody .blues td.blue { background-color: rgba(15, 66, 207, 0.03); } 
.tableSt01 tbody td.removeBr { border-bottom:0; } 
.tableSt01 tbody td > div { padding:16px; } 
.tableSt01 tbody td > div .status { display: block; width: 88px; margin: auto; padding: 2px; border-radius: 4px; font-size: 12px; line-height: 1.67; letter-spacing: -0.17px; font-weight: bold; } 
.tableSt01 tbody td > div .status.complete { color: #52c51a; background-color: rgba(0,196,46,0.1); } 
.tableSt01 tbody td > div .status.progress { color: #faad14; background-color: rgba(255,187,0,0.1); } 
.tableSt01 tbody td.allTxt > div { padding:16px 16px 16px 24px; position: relative; } 
.tableSt01 tbody td.allTxt > div strong { display:block; font-family: SamsungOne; font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; padding-bottom:8px; } 
.tableSt01 tbody td.allTxt > div .option { position: absolute; right:12px; top:18px; padding: 0; } 
.tableSt01 tbody td.allTxt > div .option.curr > button { background:#dde6fa; border-radius: 4PX; } 
.tableSt01 tbody td.allTxt > div .option.curr ul { display:block; } 
.tableSt01 tbody td.allTxt > div .option > button { width:24px; height:24px; border-radius: 4px; padding: 3px; } 
.tableSt01 tbody td.allTxt > div .option > button:hover { background-color: rgba(15, 66, 207, 0.1); } 
.tableSt01 tbody td.allTxt > div .option > button + button {  margin-left: 8px; }
.tableSt01 tbody td.allTxt > div .option > button img { width:16px; } 

.tableSt01 tbody td.allTxt > div .option ul { position: absolute; top:100%; right:0; width:140px; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; } 
.tableSt01 tbody td.allTxt > div .option ul button { width:100%; height:40px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; font-family: SamsungOne; } 
.tableSt01 tbody td.allTxt > div .option ul button:hover { background:#e6ecfb; } 
/* .tableSt01 tbody td .openr { padding:6px; } */
.tableSt01 tbody td .openr { position: relative; padding-left: 20px; display: none; font-size: 14px; line-height: 1.29; letter-spacing: -0.1px; color: #363636; font-family: Arial; text-align: left; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: 100%; } 
.innerTable.with-filter .tableSt01 tbody td .openr { display: block; } 
.tableSt01 tbody td .openr { margin-left: -4px; padding-left: 24px; }
.tableSt01 tbody td .openr img { width:16px; vertical-align: middle; margin-right:8px; position: absolute; top: 50%; left: 0; transform: translateY(-50%); } 
.tableSt01 tbody td .openr.open img { transform: translateY(-50%) rotate(180deg); } 
.tableSt01 tbody td .file {     padding: 4px; font-size: 0; line-height: 0; border-radius: 3px; margin-left: -3px; } 
.tableSt01 tbody td .file:hover {     background: rgba(15,66,207,0.1); }
.tableSt01 tbody td .file img { width:16px; } 
.tableSt01 tbody td > div p { line-height: 1.29; letter-spacing: -0.1px; color: #363636; font-family: Arial; } 
.tableSt01 tbody td .openr + p { vertical-align: top; display: inline-block; max-width: calc(100% - 24px); } 
.tableSt01 tbody tr.blues td > div p { padding-right: 64px; } 
.tableSt01 tbody td > div p a { color:#0f42cf; letter-spacing: -0.14px; }
.tableSt01 tbody td > div p a:hover { text-decoration: underline; } 
.tableSt01 thead th .picker-wrap {display: block; width: 100%; margin-top: 10px;}
.tableSt01 thead th .mx-datepicker-range {width: 100%;}
.tableSt01 thead th >>> .mx-datepicker .mx-icon-calendar { display: none;}
.tableSt01 thead th >>> .mx-datepicker .mx-icon-clear {right: 26px; }
.tableSt01 thead th >>> .mx-input {height: 24px; border-color: #d6d6d6;background: #ffffff url(/images/ic-calendar.png) calc(100% - 8px) center no-repeat;background-size: 12px;padding: 0 48px 0 8px; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; box-shadow: none; max-width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; color: #000;}
.tableSt01 thead th .clear-icon {width: 10px;height: 10px; }


.tableSt01 .scroll { max-height:257px; overflow-y:auto; } 
.innerTable.with-filter .tableSt01 .scroll { max-height:none; } 
.tableSt01 .scroll.long { max-height:478px; } 
.tableSt01 input[type=checkbox] { width:16px; height:16px; border:0; background:url(/images/icon_checkbox.png) no-repeat; margin:0; background-size:100%; } 
.tableSt01 input[type=checkbox]:checked { background:url(/images/icon_checkbox_on.png) no-repeat; margin:0; background-size:100%; } 
.tableSt01 .searchBox { margin-top:10px; position: relative; } 
.tableSt01 .searchBox .searchInput > span { display:block; position: relative; } 
.tableSt01 .searchBox .searchInput > span input[type=text] { border-radius: 4px; border: solid 1px #d6d6d6; background: #ffffff url(/images/icon_search.png) 8px center no-repeat; background-size:16px; height:24px; width:100%; padding:0 8px 0 28px; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] { border-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] + button { display:block; } 
.tableSt01 .searchBox .searchInput > span button { position: absolute; right:8px; top:50%; transform: translateY(-50%); display:none; } 
.tableSt01 .searchBox .searchInput > span button img { width:10px; } 
.tableSt01 .searchBox .searchInput.curr .absWord { display:block; } 
.tableSt01 .searchBox .searchInput .absWord { position: absolute; left:0; top:28px; width:100%; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); z-index:20; background:#fff; display:none; } 
.tableSt01 .searchBox .searchInput .absWord li button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
.tableSt01 .searchBox .searchInput .absWord li button strong { font-weight:bold; } 
.tableSt01 .searchBox .searchInput .absWord li.time button { padding-left:40px; background:url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.tableSt01 .searchBox .searchInput .absWord li button:hover { background:#e6ecfb; } 
.tableSt01 .searchBox .searchInput .absWord li.time button:hover { background:#e6ecfb url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.tableSt01 .searchBox .searchInput .absWord .btns { padding:8px 8px 8px; display: flex; justify-content: space-between; margin-top:8px; display:none; } 
.tableSt01 .searchBox .searchInput .absWord .btns button { width:calc(100% - 40px); height: 32px; border-radius: 4px; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.imgRe { width:32px; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.imgRe img { width:32px; } 
.tableSt01 .searchBox > button { display:none; } 

.infoTable { display:flex; justify-content:flex-end; align-items: center; padding:16px; box-sizing: content-box; } 
.infoTable span { font-size: 12px; line-height: 1.5; letter-spacing: -0.09px; color: #9e9e9e; } 
.infoTable > * { margin-left:8px; } 
.infoTable span:first-child { margin-left: 0; } 
.infoTable > .btns { margin: -8px -4px -8px 8px; padding-left:12px; position: relative; text-align: right; } 
.infoTable > .btns::before { content:''; position: absolute; left:0; top:50%; transform: translateY(-50%); width:1px; height:16px; background:#ebebed; } 
.infoTable > .btns button { margin: 4px; vertical-align: middle; line-height:0; background-color: #fff; border-radius: 4px; border: 1px solid #d6d6d6; padding: 3px; } 
.infoTable > .btns button img { width:16px; } 
.infoTable > .btns button.prev img { transform: rotate(180deg); opacity: 0.2; } 
.selects { position: relative; } 
.selects > button { border-radius: 4px; border: solid 1px #d6d6d6; background-color: #ffffff; } 
.selects.curr ul { display:block; } 
.selects > ul { position: absolute; top:100%; left:0; width:100%; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); display:none; background-color: #fff; margin-top: 4px; } 
.selects > ul button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
.selects > ul button:hover { background:#e6ecfb; } 

.selects .absList { position: absolute; background:#fff; right:0; top:100%; width:100%; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; z-index: 10; } 
.selects.curr .absList { display:block; } 
.selects .absList .all { margin: 0 8px; padding:10px 0; border-bottom:1px solid #ebebed; } 
.selects .absList ul { padding-top:8px; } 
.selects .absList li { padding:10px 8px; } 
.selects .absList li:hover { background:#e6ecfb; } 
.selects .absList label { font-family: SamsungOne; font-size: 14px; font-weight:normal; line-height: 1.43; color: #363636; margin-left:8px; } 
.selects .absList .btns { padding:8px 8px 0; display: flex; justify-content: space-between; margin-top:8px; } 
.selects .absList .btns button { width:calc(50% - 4px); height: 32px; border-radius: 4px; font-family: SamsungOne; } 
.selects .absList .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.selects .absList .btns button.btnRe { font-size: 14px; font-weight: bold; color: #363636; background-color: #fff; border: solid 1px #d6d6d6; } 

.selects.type02 > button { padding:0 36px 0 12px; position: relative; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; color: #363636; height:32px; text-align:left; } 
.selects.type02 > button::after { content:''; position: absolute; right:12px; top:50%; transform: translateY(-50%); width:16px; height:16px; background:url(/images/arrow-light.png) no-repeat; background-size:100%; } 
.selects.type02 > button.active::after { transform: translateY(-50%) rotate(180deg); }
.selects.type03 > button { width: 80px; padding:0 28px 0 8px; position: relative; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; color: #363636; height:24px; text-align:left; } 
.selects.type03 > button::after { content:''; position: absolute; right:8px; top:50%; transform: translateY(-50%); width:12px; height:12px; background:url(/images/icon_openr_off.png) no-repeat; background-size:100%; } 
.selects.type03 ul button { width:100%; height:40px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 12px; font-family: SamsungOne; } 
.selects > button.off { color: #9e9e9e; } 


.tabSt01 { } 
.tabSt01 ul { display:flex; align-items: center; position: relative; } 
.tabSt01 ul::before { content:''; position: absolute; left:0; bottom:0; background:#d6d6d6; width:100%; height:2px; z-index: -1; } 
.tabSt01 ul button { height:52px; font-size: 16px; line-height: 1.5; color: #9e9e9e; padding:0 24px; text-transform: uppercase; font-family: SamsungOne; } 
.tabSt01 ul .curr button { color:#363636; border-bottom:2px solid #000; font-weight: bold; letter-spacing: -0.16px; } 


@media all and (max-width:1000px){
 .innerTable { width:100%; overflow-x:auto; } 
 .innerTable .scrollX { width:1000px; } 
 .tableSt01 .scroll { max-height: none; } 
 .tableSt01 thead .only th .inbox { padding-right:8px; } 
 .tableSt01 thead .only th .inbox .str { width:calc(100%) } 
 .tableSt01 .searchBox { margin-top:0px; position: static; } 
 .tableSt01 .searchBox .searchInput { display:none; } 
 .tableSt01 .searchBox .searchInput > span { display:block; position: relative; } 
 .tableSt01 .searchBox .searchInput > span input[type=text] { border-radius: 4px; border: solid 1px #d6d6d6; background: #ffffff url(/images/icon_search.png) 8px center no-repeat; background-size:16px; height:24px; width:100%; padding:0 8px 0 28px; } 
 .tableSt01 .searchBox .searchInput.curr > span input[type=text] { border-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] + button { display:block; } 
 .tableSt01 .searchBox .searchInput > span button { position: absolute; right:8px; top:50%; transform: translateY(-50%); display:none; } 
 .tableSt01 .searchBox .searchInput > span button img { width:10px; } 
 .tableSt01 .searchBox .searchInput.curr .absWord { display:block; } 
 .tableSt01 .searchBox .searchInput .absWord { position: absolute; left:0; top:28px; width:100%; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); z-index:20; background:#fff; display:none; } 
 .tableSt01 .searchBox .searchInput .absWord li button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
 .tableSt01 .searchBox .searchInput .absWord li button strong { font-weight:bold; } 
 .tableSt01 .searchBox .searchInput .absWord li.time button { padding-left:40px; background:url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
 .tableSt01 .searchBox .searchInput .absWord li button:hover { background:#e6ecfb; } 
 .tableSt01 .searchBox .searchInput .absWord li.time button:hover { background:#e6ecfb url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
 .tableSt01 .searchBox .searchInput .absWord .btns { display:block; display:flex; } 
 .tableSt01 .searchBox > button { display:block; position: absolute; right:8px; top:50%; transform: translateY(-50%); font-size:0; line-height:0; width:16px; height:16px; background:url(/images/icon_search.png) no-repeat; background-size:100%; } 
 .tableSt01 .curr .searchBox > button { background:url(/images/icon_search_on.png) no-repeat; background-size:100%; } 
 .tableSt01 .curr .searchBox .searchInput { display:block; position: absolute; right:8px; top:45px; width:150%; } 
 .tableSt01 .curr .searchBox .searchInput > span input[type=text] { height:40px; } 
 .tableSt01 .curr .searchBox .searchInput .absWord { display:block; top:44px; } 
.tableSt01 thead th .picker-wrap { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); width: 16px; margin-top: 0; }
.tableSt01 thead th >>> .mx-input { height: 0; padding: 8px; width: 0; border: none; background-color: transparent; background-position: right center; cursor: pointer; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; background-size: 16px;}
 .tableSt01 thead th.file .inbox { padding-bottom: 15px; }
 .tableSt01 thead th.file .str { justify-content: initial; }

 
 .infoTable { background-color: #f7f7f7; } 
 .infoTable > * { margin-left:8px; } 

.tableWrap .titArea { min-height: 40px; padding-top: 8px; }
 .tableWrap .titArea .tit { font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 
 .tableWrap .titArea .alignRight { position: static; transform: translateY(0%); display:block; margin-top:22px; } 
 .tableWrap .titArea .alignRight .selects { display:inline-block; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight .selects button { width:calc(100%) !important; height:40px; } 
 .tableWrap .titArea .alignRight .selects + .excel { width:calc(50% - 4px); height:40px; } 
 .tableWrap .titArea .alignRight .excel { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
 .tableWrap .titArea .alignRight .del { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
 .tableWrap .titArea .alignRight.basic .selects { display:block; width:100%; } 
 .tableWrap .titArea .alignRight.basic .del { margin-left:0; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .edit { margin-left:0; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .add { margin-left:0; margin-right: 8px; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .edit + .del { margin-left: 8px; } 
 .tableWrap .titArea .alignRight.basic .excel { margin-left:8px; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic.only button { margin-left:0; height:40px; margin-top:0; width:100%; } 
 .tableWrap .titArea .alignRight.basic button:nth-child(3) { margin-left:0; margin-top: 8px; width: 100%; } 
 .tableWrap .titArea .alignRight.basic.even button { width: calc(33.33% - 8px) !important; margin: 0 4px !important; } 
 .tableWrap .titArea .alignRight.basic.even { margin: 22px -4px 0; } 
 .tableSt01 tbody td .openr { display: inline-block; }
 .tableSt01 tbody .blues { display: none; }
 .tableSt01 tbody td.allTxt > div { display: flex; width: calc(100vw - 48px); padding-left: 45px; }
.tableSt01 tbody tr.blues td > div p { padding-right: 48px; }
.tableSt01 tbody td.allTxt > div .option { right: 19px; top: 16px; }
.tableSt01 tbody td.allTxt > div .option > button { display: block; }
.tableSt01 tbody td.allTxt > div .option > button + button { margin-left: 0; margin-top: 8px; }
.selects.type03 > button { width: 72px; height: 32px; } 
.infoTable > .btns button { padding: 7px; }
.infoTable > .btns { margin-left: 8px; }
.selects.type02 > button { height: 40px; font-size: 16px; }
.selects .absList label { font-size: 16px; }
 }

</style>